/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { WORKSTATION_ROOM } from "../RoomNameConstants";

const state = {
    ID: WORKSTATION_ROOM,
    criticalJobsData: {
        "Critical Jobs Info High Risk": [],
        "Critical Jobs Info Potential Risk": [],
        "Critical Jobs Info No Risk": [],
    },
    barPanelData: {
        values: [
            {
                values: [20],
                labels: [],
                colors: ["#363636"],
            },
            {
                values: [10],
                labels: ["Running"],
                colors: ["#363636"],
            },
            {
                values: [10],
                labels: ["Successful"],
                colors: ["#363636"],
            },
            {
                values: [18],
                labels: ["Error"],
                colors: ["#363636"],
            },
            {
                values: [22],
                labels: ["Suppressed"],
                colors: ["#363636"],
            },
        ],
        labels: [],
        selected: null,
    },
};

export default state;
